export function isNullish(value): value is null | undefined {
  return value === null || value === undefined;
}
